/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Injectable } from "@angular/core";
import { VcClientAPI } from "../vc-client-api";
import { VcClientSdk } from "./vc-client-sdk";
import { ProtocolUtil } from "../../../vdpservice/util";
import { ChannelManager } from "../channel-manager";
import { vcTransportMsgSchema } from "../../definitions/vc-transport-message.schema";
import { SDKRequestIds } from "../../../../../../../SDK/src/util/event-service";
import { ChannelDescriptor, ConnectCallback } from "../vc-client";

@Injectable()
export class VcClientAPISdk extends VcClientAPI {
   protected optionString;
   private scannerSendFunction;
   private static readonly CHANNEL_OPTIONS = "VMWscan,0";
   constructor(private vcClientSdk: VcClientSdk) {
      super();
   }
   public init = (uuid, sessionKey, channelOptions, sendFunction) => {
      if (channelOptions) {
         channelOptions += ",";
      }
      channelOptions += VcClientAPISdk.CHANNEL_OPTIONS;
      this.vcClientSdk.initSDK(uuid, channelOptions, {
         onReceiveData: this.onReceiveVChanData,
         onVchanConnected: this.onVchanConnected,
         onVchanDisconnected: this.onVchanDisconnected
      });
      this.logger.info("vchan option inited as: " + JSON.stringify(channelOptions));
      this.sendFunctions = sendFunction;
      if (!this.inited) {
         this.channelhelper = ProtocolUtil.getHelper(vcTransportMsgSchema);
         this.channelManager = new ChannelManager(sessionKey, uuid);
         this.channelManager.$channelConnected.subscribe(this.onVchanConnected);
         this.channelManager.$channelDisconnected.subscribe(this.onVchanDisconnected);
         this.inited = true;
      }
   };

   public updateScannerCallBack = (sendFunc) => {
      this.scannerSendFunction = sendFunc;
   };

   public onReceiveVChanData = (channelInfo: ChannelDescriptor, data: Uint8Array) => {
      this.logger.trace("receive vchan message on " + channelInfo.channelName);
      this.logger.dump("message data: " + JSON.stringify(Array.from(data)));
      if (channelInfo.channelName === "VCPING") {
         this.sendFunctions(SDKRequestIds.VchanFromRemoteData, {
            channelInfo: channelInfo,
            data: Array.from(data)
         });
      } else {
         if (this.scannerSendFunction) {
            this.scannerSendFunction(data);
         }
      }
   };
   public onVchanConnected: ConnectCallback = (channelInfo: ChannelDescriptor) => {
      this.logger.info("vchan opened" + channelInfo.channelName);
      if (channelInfo.channelName === "VCPING") {
         this.sendFunctions(SDKRequestIds.VchanConnected, {
            channelInfo: channelInfo
         });
      }
   };
   public onVchanDisconnected = (channelInfo: ChannelDescriptor) => {
      this.logger.info("vchan closed" + channelInfo.channelName);
      if (channelInfo.channelName === "VCPING") {
         this.sendFunctions(SDKRequestIds.VchanDisconnected, {
            channelInfo: channelInfo
         });
      }
   };
}
